// eslint-disable-next-line import/prefer-default-export
export const PASSTHRU_SET_MESSAGES = (state, { messages }) => ({
  ...state,
  messages
});
